import { ReactNode } from 'react';
import { Page } from '@/components';
import { Skeleton } from '@blockanalitica/ui';

export default function PageSkeleton({
  children
}: {
  children?: ReactNode | ReactNode[];
}) {
  return <Page title={<Skeleton width="10" height="6" />}>{children}</Page>;
}
